import { render } from "./forest_ploat.vue?vue&type=template&id=79fbfa3c&scoped=true"
import script from "./forest_ploat.vue?vue&type=script&lang=js"
export * from "./forest_ploat.vue?vue&type=script&lang=js"

import "./forest_ploat.vue?vue&type=style&index=0&id=79fbfa3c&lang=css"
import "./forest_ploat.vue?vue&type=style&index=1&id=79fbfa3c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fbfa3c"]])

export default __exports__